

export default function ({$gtm, route}) {
  $gtm.init('GTM-NFFJ84F')


}
